const initialState = {
  detailData: null,
  err: null
}

export default function mediaReducer(state = initialState, action) {
  const { type, payload, err } = action

  switch (type) {
    case 'GET_MEDIA_DETAIL':
      return initialState

    case 'GET_MEDIA_DETAIL_SUCCESS':
      return {
        detailData: payload
      }

    case 'GET_MEDIA_DETAIL_ERROR':
      return {
        err
      }

    case 'CLEAR_MEDIA_DETAIL':
      return initialState

    default:
      return state
  }
}
